/**
 * @file Allow using app feature flags
 */
import { hasWwDebugUrlParam } from '@@/bits/dev_url_params'
import environment from '@@/bits/environment'
import window from '@@/bits/global'

type CurrentFlags =
  | 'accessControlSettingsV2'
  | 'accessControlSettingsV2RetroactiveUpdate'
  | 'actionMenu2026'
  | 'addPostLink'
  | 'adminAnalyticsNuxtUi'
  | 'affiliateSignupLink'
  | 'aiImageSearch'
  | 'aiMakeFromPrompt'
  | 'aiPermissionsForAiRecipes'
  | 'aiPermissionsForImageAndSpeechGeneration'
  | 'aiSuggestionsOnMakePage'
  | 'allSlideAsImageWithBanksy'
  | 'arLensesPreview'
  | 'attachmentPreviewWidthAdjustmentForGridFormat'
  | 'autoContentModeration'
  | 'banksy'
  | 'banksyDev'
  | 'billingAddress'
  | 'bulkEmailChangeForLibraries'
  | 'brahmsCheck'
  | 'campus'
  | 'changeEmailVerification'
  | 'classesV1'
  | 'classInformation'
  | 'classlinkSso'
  | 'classroomLicensesV2'
  | 'classroomPlanPricingExperiment'
  | 'cleverSso'
  | 'commandBar'
  | 'commentAutoPublishOnUpload'
  | 'crossPlatformAttachmentSettings'
  | 'currentSlideAsImageWithBanksy'
  | 'customPostUserProperty'
  | 'customPostVoteAndRatingProperties'
  | 'dailyEmailDigestTeacher'
  | 'v2EmailDigestTreatment'
  | 'dashboardAnnouncement'
  | 'dashboardUpgradeCta'
  | 'dashboardWallRemake'
  | 'dashHeaderCtaButton'
  | 'dashRecentsGroupByLibrary'
  | 'debugFrontend'
  | 'defaultDashboardLibraryNavigation'
  | 'demoPadletPanel'
  | 'demoPadletSignup'
  | 'deprecateArsPlans'
  | 'deprecateDrivePage'
  | 'deprecateGoldPlans'
  | 'deviceIdLocalStorageReseed'
  | 'deviceUploads'
  | 'displayLocalPartRules'
  | 'downloadWallAttachmentsV2'
  | 'editThumbnail'
  | 'editThumbnailForAudioVideoFiles'
  | 'embeddedPadletsOnExpandedPost'
  | 'embedLogin'
  | 'exitTicket'
  | 'expandedViewForTextPosts'
  | 'fasterDashSettings'
  | 'featuredSection'
  | 'fetchLinksWithWishes'
  | 'frontChat'
  | 'fullClientSurface'
  | 'galleryTemplates'
  | 'googleAppLicensing'
  | 'googleClassroom'
  | 'googleClassroomGrading'
  | 'googleWorkspaceRostering'
  | 'grading'
  | 'groupPostsV2'
  | 'higherMonthlyPricingPlans'
  | 'inboundEmailVerification'
  | 'internalNavigateImmediately'
  | 'joypixels8p0'
  | 'landsideWorkerNavigation'
  | 'latamSpanishLanguage'
  | 'libraryGoogleAppLicensing'
  | 'libraryLoginOtpToggle'
  | 'librarySamlLogin'
  | 'librarySettingsConnectionsTab'
  | 'librarySsoVerificationToggle'
  | 'lmsUserGroupSync'
  | 'loadWishesViaSortBy'
  | 'lottieWebWorker'
  | 'ltiCourseDuplication'
  | 'ltiV1p3WithoutDeepLinking'
  | 'magicPadlet'
  | 'makePageSimplifiedLayoutExperiment'
  | 'maoriLanguage'
  | 'membersSelectV2'
  | 'microsoftOneDrivePicker'
  | 'microsoftTeams'
  | 'mobileDeviceDprOverride'
  | 'notifyFailedPayments'
  | 'posthogNpsSurvey'
  | 'posthogNpsSurveyAlwaysShow'
  | 'onboardingDemoV2'
  | 'onboardingDemoV2Copy'
  | 'onboardingGridLayout'
  | 'onboardingPanel'
  | 'openInAppBanner'
  | 'openInAppOnAccessGate'
  | 'openInMobileApp'
  | 'padletLive'
  | 'pdndSurfaceGrid'
  | 'pdndSurfaceMap'
  | 'pdndSurfaceMatrix'
  | 'personalPricingPlansExperiment'
  | 'personalPricingPlansExperimentV2'
  | 'piChatV2'
  | 'piInputV2'
  | 'pinsightInSurface'
  | 'piSandboxChat'
  | 'piSubmissionFormWidget'
  | 'piUndo'
  | 'platinumResellerSelfServe'
  | 'playVideoInExpanded'
  | 'postComposerAttachmentPickerV2'
  | 'postVisibility'
  | 'posthogSessionRecording'
  | 'pptxImport'
  | 'prefetchSurface'
  | 'publicApi'
  | 'pwaInstallButton'
  | 'reactionsToCustomPropertiesMigration'
  | 'remakeLink'
  | 'showRemakeLinkQr'
  | 'remakeSettingV2'
  | 'removeArchive'
  | 'renameAdminOwnerToCreator'
  | 'requirePaymentMethodToUndoCancellation'
  | 'rostering'
  | 'routeToEurope'
  | 'rowsSectionScrubber'
  | 'samlIdp'
  | 'samlSetup'
  | 'sandboxAi'
  | 'whiteboardPermissionsV2'
  | 'sandboxCardScroll'
  | 'sandboxGeoShapeBorderSettings'
  | 'sandboxLevelAllowedToolsReposition'
  | 'sandboxNotePlaceholders'
  | 'sandboxMultiShapeColorUpdate'
  | 'sandboxPerCardAllowedTools'
  | 'sandboxRadialMenu'
  | 'sandboxSimplifiedRoles'
  | 'schoolLibraryFreeze'
  | 'schoolLibraryPermissions'
  | 'schoolLibrarySSO'
  | 'schoolSelectionForTeachers'
  | 'scrollSmoothnessTracking'
  | 'selfServeFreeTrial'
  | 'selfServePaymentMethodRemoval'
  | 'shareShortcuts'
  | 'showAnonymousUserNames'
  | 'showCommandPalette'
  | 'showInvitedLibraryUsers'
  | 'sidePanelsV2'
  | 'signUpSurface'
  | 'slideshowRemote'
  | 'slideshowSwipeNavigation'
  | 'smartSuggestionsExperiment'
  | 'structuredClassInformation'
  | 'suggestedTemplates'
  | 'surfaceAiChat'
  | 'surfaceAiChatSchools'
  | 'surfaceAiChatSchoolsPermission'
  | 'surfaceCommentsPerPost'
  | 'surfaceCommentVideoPlayer'
  | 'surfaceConnectionsChange'
  | 'surfaceContributorsModalV2'
  | 'surfacePostVideoPlayer'
  | 'surfaceLibraryOrgVisitorPermissions'
  | 'surfaceMapsV2'
  | 'surfaceRoleBadges'
  | 'surfaceShiftTextSelection'
  | 'surfaceTranslateFeedback'
  | 'swipeNavigationOnBoardExpandedView'
  | 'tableColumnHeaderSorting'
  | 'tamilLanguage'
  | 'taxIdOnCheckout'
  | 'threeDAttachment'
  | 'templatesWithNewSidebar'
  | 'transferPadletTool'
  | 'transferPostWithCustomProperties'
  | 'transferSchoolPadletPermission'
  | 'translatePadlet'
  | 'translatePadletV2'
  | 'translationFeedback'
  | 'translationReporter'
  | 'turnstileOnSignup'
  | 'undoRedoDeleteSectionActions'
  | 'unicodeFontLoading'
  | 'unlimitedSandboxesEventOverQuotaBanner'
  | 'unlimitedSandboxesV2'
  | 'upgradeModalCopyAExperiment'
  | 'upgradeModalSingleStepExperiment'
  | 'viewAsPreview'
  | 'virtualFieldTrip'
  | 'virtualFieldTripNarration'
  | 'virtualizedDashboard'
  | 'virtualizedPostsGrid'
  | 'wallCardMaxWidth'
  | 'wallContentProtection'
  | 'wallEngagementTime'
  | 'wallEngagementTimeTracking'
  | 'workspaceLoginRedirect'
  | 'yodishLanguage'
  | 'zapierIntegration'
  | 'nativeAccountSwitcher'
  | 'captionsTranslation'
  | 'arcadeAttachment'
  | 'arcadeGameInsightsEmailTeacher'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const viteAppFlip =
    window.wwStartingState != null && typeof window.wwStartingState === 'function' ? window.wwStartingState().flip : {}
  const flip = ww.flip || ww.vueStartingState?.flip || viteAppFlip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

const isDebugMode =
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  hasWwDebugUrlParam()

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

// If on padlet.dev, use the local Banksy server to test PDF exports.
// Banksy and Banksy Dev on Cloud Run won't work because they cannot access a padlet.dev padlet.
// You will need to run the Banksy server first before you can test PDF exports.
// See: /services/banksy/README.md
const isAppUsingBanksyLocalDev = environment === 'development'

export { isAppUsing, isAppUsingBanksyLocalDev, isDebugMode }
export type { CurrentFlags }
